import _ from 'underscore';

// TODO: [yaoyao] Do we need to lazy load the data-fetch module based on preference data?
import { getAuctionInsightDataSource } from '@bingads-webui-campaign-legacy/dashboard-cards/competition-card/data-fetch';
import { fetchPerformanceTimeSeries } from '@bingads-webui-campaign-legacy/performance-graph/data-fetch';
import {
  fetchCoupons,
  fetchTopChanges,
  fetchAggregatedData,
} from '@bingads-webui-campaign/overview-cards-common';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import state from '@bingads-webui-component-legacy/state/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';

import { setDFMCache, withDFMCache } from '@bingads-webui/dfm-cache';
import {
  // We only need to enable DFM for cards in account level page
  // Customer level and campaign level won't hit the code in this file
  cardPerformanceId, // need preference logic to enable DFM
  cardRecommendationsId,
  cardTopCampaignsId, // need preference logic to enable DFM
  cardTopKeywordsId, // need preference logic to enable DFM
  cardSearchTermsId, // need preference logic to enable DFM
  cardCompetitionId,
  cardDeviceId,
  cardConversionTrackingId, // preference is disabled for this card somehow
  cardTopChangesCampaignId, // need preference logic to enable DFM
} from '@bingads-webui-campaign/fluent-page-consts';

import {
  getCardPreferenceWithDefault,
  getCardPreferenceOptionsForDfm,
} from '../preference/preference-helper';
import { getDfmPreferenceObjectForPerformanceTable } from '../preference/card-preference/performance-table';
import { getInitSelectedCardsConfig } from '../preference/use-selected-cards-with-preference';

import { getFluentCardsConfigs } from '../cards-configs/fluent-card-configs';

import { getNavigationLevel } from '../helper/get-navigation-level';
import { getCcJsData } from '../helper/get-cc-jsdata';
import { isInViewPort, getViewPortCardsCount } from '../helper/get-responsive-size';

import {
  fetchRecommendations,
  fetchTips,
} from '../data-fetch/recommendation-card';
import {
  fetchGridTileData,
} from '../data-fetch/grid-data';
import {
  fetchConversionTrackingData,
} from '../data-fetch/conversion-tracking';

function getOptionsForCard({
  config,
  navigationLevel,
  campaignType,
  preference,
  getDfmPreferenceObject,
  permissions,
}) {
  const cardPreference = getCardPreferenceWithDefault({
    config,
    navigationLevel,
    campaignType,
    preference,
    permissions,
  });

  let options = cardPreference;
  if (options && getDfmPreferenceObject) {
    options = getDfmPreferenceObject(cardPreference);
  }
  return options;
}

export function fetchFluentOverviewTilesData({
  filter,
  campaignType,
  resolve,
  DateFilterState,
  preference,
  queryParam,
  serverContext,
  jsdata,
  permissions,
  legacyConfig,
  featureInstrumentation,
}) {
  const {
    uid, cid, aid, campaignId, adGroupId,
  } = queryParam.values;
  const scope = {
    values: {
      uid, cid, aid, campaignId, adGroupId,
    },
  };
  const navigationLevel = getNavigationLevel(scope.values);
  const p$DateRange = new DateFilterState({ state }).p$State;
  const cardsConfigs = getFluentCardsConfigs({
    permissions,
  });

  const selectedCardsConfig = getInitSelectedCardsConfig({
    preference,
    cardsConfigs,
    navigationLevel,
    campaignType,
    serverContext,
    isSDK: false,
  });

  const cardIds = _.map(selectedCardsConfig, 'typeId');
  let viewPortCardSize = getViewPortCardsCount(selectedCardsConfig);
  const isPerformanceInViewPort = isInViewPort(cardIds, cardPerformanceId, viewPortCardSize);
  const isDeviceInViewPort = isInViewPort(cardIds, cardDeviceId, viewPortCardSize);
  const isRecommendationInViewPort = isInViewPort(cardIds, cardRecommendationsId, viewPortCardSize);
  const isTopCampaignsInViewPort = isInViewPort(cardIds, cardTopCampaignsId, viewPortCardSize);
  const isKeywordInViewPort = isInViewPort(cardIds, cardTopKeywordsId, viewPortCardSize);
  const isSearchTermInViewPort = isInViewPort(cardIds, cardSearchTermsId, viewPortCardSize);
  const isCompetitionInViewPort = isInViewPort(cardIds, cardCompetitionId, viewPortCardSize);
  const isConversionTrackingInViewPort = isInViewPort(cardIds, cardConversionTrackingId, viewPortCardSize);
  const isTopChangesCampaignInViewPort = isInViewPort(cardIds, cardTopChangesCampaignId, viewPortCardSize);

  const getCardsConfig = () => _.map(selectedCardsConfig, config => getCardPreferenceOptionsForDfm({
    config,
    navigationLevel,
    campaignType,
    preference,
    permissions,
  }));
  window.FluentOverviewPageDataFetchManagerCardsConfigObject = {
    config: getCardsConfig(),
    campaignType,
    viewPortCardSize,
    isKeywordInViewPort,
    isSearchTermInViewPort,
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
  };

  if (viewPortCardSize <= 0) {
    resolve();
    return;
  }

  const ccJsData = getCcJsData({
    serverContext,
  });

  const dfmDataFetchCallback = () => {
    viewPortCardSize -= 1;
    if (viewPortCardSize <= 0) {
      resolve();
    }
  };

  // current dfm logic is checking edm.currentAccount, we follow this logic here
  if (isPerformanceInViewPort && edm.currentAccount !== null) {
    p$DateRange
      .then((dateRange) => {
        const p$PerformanceAggregatedData = fetchAggregatedData({
          navigationLevel: 'account',
          entitySet: edm.currentAccount.Campaigns,
          dateRange,
          getCardsConfig,
          jsdata,
          filter,
          dateUtil,
          permissions,
          campaignType,
        });
        const p$PerformanceTimeSeries = fetchPerformanceTimeSeries({
          getCardsConfig,
          entitySet: edm.currentAccount.Campaigns,
          period: dateRange,
          filter,
          campaignType,
        });

        setDFMCache(`${cardPerformanceId}-aggregated-data`, p$PerformanceAggregatedData);
        setDFMCache(`${cardPerformanceId}-time-series`, p$PerformanceTimeSeries);

        dfmDataFetchCallback();
      });
  }

  if (isDeviceInViewPort && edm.currentAccount !== null) {
    p$DateRange
      .then((dateRange) => {
        const p$DeviceAggregatedData = fetchAggregatedData({
          navigationLevel: 'account',
          entitySet: edm.currentAccount.Campaigns,
          dateRange,
          getCardsConfig,
          jsdata,
          filter,
          dateUtil,
          permissions,
          campaignType,
        });

        setDFMCache(cardDeviceId, p$DeviceAggregatedData);

        dfmDataFetchCallback();
      });
  }

  if (isRecommendationInViewPort) {
    fetchCoupons({
      ccJsData,
    });
    fetchTips({
      aid,
      cid,
    });
    fetchRecommendations({
      navigationLevel,
      featureInstrumentation,
      legacyConfig,
      permissions,
      serverContext,
      campaignType,
      ccJsData,
      cid,
      aid,
      campaignId,
    });
    dfmDataFetchCallback();
  }

  if (isTopCampaignsInViewPort) {
    const config = selectedCardsConfig.find(c => c.typeId === cardTopCampaignsId);
    const options = getOptionsForCard({
      config,
      navigationLevel,
      campaignType,
      preference,
      getDfmPreferenceObject: getDfmPreferenceObjectForPerformanceTable,
      permissions,
    });

    const p$TopCampaigns = fetchGridTileData({
      entitySet: edm.currentAccount.Campaigns,
      filter,
      options,
      getCardsConfig,
      p$DateRange,
      jsdata,
      dateUtil,
      permissions,
      campaignType,
    });

    setDFMCache(cardTopCampaignsId, p$TopCampaigns);

    dfmDataFetchCallback();
  }

  if (isKeywordInViewPort) {
    const config = selectedCardsConfig.find(c => c.typeId === cardTopKeywordsId);
    const options = getOptionsForCard({
      config,
      navigationLevel,
      campaignType,
      preference,
      getDfmPreferenceObject: getDfmPreferenceObjectForPerformanceTable,
      permissions,
    });

    const p$TopAccountKeyword = fetchGridTileData({
      entitySet: edm.currentAccount.Keywords,
      filter,
      options,
      p$DateRange,
      jsdata,
      dateUtil,
      permissions,
      campaignType,
    });

    setDFMCache(cardTopKeywordsId, p$TopAccountKeyword);

    dfmDataFetchCallback();
  }

  if (isSearchTermInViewPort) {
    const config = selectedCardsConfig.find(c => c.typeId === cardSearchTermsId);
    const options = getOptionsForCard({
      config,
      navigationLevel,
      campaignType,
      preference,
      getDfmPreferenceObject: getDfmPreferenceObjectForPerformanceTable,
      permissions,
    });

    const p$TopAccountSearchTerms = fetchGridTileData({
      entitySet: edm.currentAccount.SearchTerms,
      filter,
      options,
      p$DateRange,
      jsdata,
      dateUtil,
      permissions,
      campaignType,
    });

    setDFMCache(cardSearchTermsId, p$TopAccountSearchTerms);

    dfmDataFetchCallback();
  }

  if (isCompetitionInViewPort) {
    const dataSource = getAuctionInsightDataSource();

    const p$CompetitionTile = dataSource.query();

    dataSource.query = withDFMCache(dataSource.query, cardCompetitionId);

    setDFMCache(cardCompetitionId, p$CompetitionTile);

    dfmDataFetchCallback();
  }

  if (isConversionTrackingInViewPort) {
    fetchCoupons({
      ccJsData,
    });

    const p$ConversionTracking = fetchConversionTrackingData({
      entitySet: edm.currentAccount.Campaigns,
      filter,
      getCardsConfig,
      p$DateRange,
      jsdata,
      dateUtil,
      permissions,
      campaignType,
    });

    setDFMCache(cardConversionTrackingId, p$ConversionTracking);

    dfmDataFetchCallback();
  }

  if (isTopChangesCampaignInViewPort) {
    p$DateRange.then((dateRange) => {
      const p$TopChangesCampaign = fetchTopChanges({
        entitySet: edm.currentAccount.Campaigns,
        dateRange,
        filter,
        jsdata,
        dateUtil,
        getCardsConfig,
        permissions,
        campaignType,
      });

      setDFMCache(cardTopChangesCampaignId, p$TopChangesCampaign);

      dfmDataFetchCallback();
    });
  }
}
